import React from 'react';

import { PDFIcon, PlayIcon } from './Assets';
import { connect } from 'react-redux';
import './complete-survey.scss';

import { LinkIcon } from '../../Assets';

const CompleteSolution = ({ isResource, resources, solutions }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'document':
        return <PDFIcon />;
      case 'video':
        return <PlayIcon />;
      default:
        return <LinkIcon />;
    }
  };

  const list = isResource ? resources : solutions;

  return (
    <div className="complete-solution-wrapper">
      <h4>{isResource ? 'Resources' : 'Action Steps'}</h4>
      {list.length ? (
        <ul className="solution-list">
          {list.slice(0, 3).map((solution, index) => (
            <li key={index}>
              <a
                className="d-flex align-items-sm-center"
                href={solution.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {getIcon(solution.media_type)}
                <p>{solution.label}</p>
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <div>No {isResource ? 'Resources' : 'Solutions'}</div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  resources: state.resources.resourcesMe,
  solutions: state.solutions.solutionsLatest,
  loading: state.solutions.getSolutionsMe.loading,
  error: state.solutions.getSolutionsMe.error,
});

export default connect(mapStateToProps)(CompleteSolution);
